export const parseVideoSources = (sources) => {
    return sources.map(x => {
        return {
            label: x.res,
            file: x.uri,
            default: x.res === '1080p'
        };
    });
};

export const getVideoById = (videos, videoId) => {
    return videos.find(video => video.aid === videoId);
};
